import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import * as invoiceTermService from "../services/invoiceTermService";

export const useInvoiceTerms = () => {
    const [terms, setTerms] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchData = async () => {
        try {
            setLoading(true);
            const res = await invoiceTermService.getInvoiceTerms();
            setTerms(res.data.terms || []);
        } catch (err) {
            toast.error("Failed to load invoice terms");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const deleteTerm = async (id) => {
        if (!window.confirm("Are you sure you want to delete this clause?")) return;
        try {
            await invoiceTermService.deleteInvoiceTerm(id);
            toast.success("Clause deleted successfully");
            fetchData();
        } catch (err) {
            toast.error("Failed to delete clause");
        }
    };

    const toggleActive = async (id, currentStatus) => {
        try {
            await invoiceTermService.toggleActive(id, !currentStatus);
            setTerms(prev => prev.map(t => t._id === id ? { ...t, isActive: !currentStatus } : t));
            toast.success(`Clause ${!currentStatus ? 'enabled' : 'disabled'}`);
        } catch (err) {
            toast.error("Failed to update status");
        }
    };

    return {
        terms,
        loading,
        fetchData,
        deleteTerm,
        toggleActive
    };
};
